<template>
  <div class="chief">
    <div class="box">
      <div class="switch-wrapper">
        <b-switch v-model='chief.isHidden' @change="handleUpdate">Скрыть сотрудника</b-switch>
      </div>
      <img src="/static/img/icons/delete.svg" class="delete-icon" @click="deleteChief(chief.id)"/>
      <div v-if="!chief.photo" class="load-photo-wrapper centered">
        <span class="button-wrapper" @click="handleLoadChiefPhoto">
          <a class="button is-info">+</a> Добавить фото
        </span>
        <input type="file" id='photo' @change='loadPhoto' hidden ref="loadPhotoButton"/>
      </div>
      <div class="photo-container" v-else v-bind:style="photoStyle">
        <a class="button is-danger delete-photo" @click="deleteChiefPhoto(chief.id)">Удалить фото</a>
      </div>
      <div class="inputs">
        <b-input v-model="chief.name" placeholder="Имя" @change="handleUpdate"/>
        <b-input v-model="chief.position" placeholder="Должность" @change="handleUpdate"/>
        <b-input v-model="chief.citation" placeholder="Цитата" @change="handleUpdate" type="textarea"/>
      </div>
      <div class="centered">
        <button class="button save-content" @click="handleSave()" :disabled="disabled">{{ disabled ? 'Идет сохранение...' : 'СОХРАНИТЬ' }}</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'ChiefItem',
  data () {
    return {
      updateTimer: 0,
      disabled: false
    }
  },
  props: {
    chief: {
      type: Object,
      required: true
    }
  },
  computed: {
    photoStyle () {
      return this.chief.photo
      ? {background: !this.chief.photo.base64photo
        ? `url(/upload/photos/${this.chief.photo})`
        : `url(${this.chief.photo.base64photo})`}
      : {background: ''}
    }
  },
  methods: {
    ...mapActions(['deleteCheif', 'updateCheif', 'loadChiefPhoto', 'deleteChief', 'saveChief']),
    handleUpdate () {
      this.updateCheif(this.chief)
    },
    handleLoadChiefPhoto () {
      this.$refs.loadPhotoButton.click()
    },
    handleSave () {
      this.disabled = true
      this.saveChief(this.chief)
      .then(() => {
        this.disabled = false
        this.$toast.open({ message: 'Сохранено' })
      })
    },
    loadPhoto (e) {
      const reader = new FileReader()
      reader.readAsDataURL(e.target.files[0])
      const formData = new FormData()
      const file = e.target.files[0]
      formData.set('avatar', file)
      reader.onload = (e) => {
        this.chief.photo = {
          base64photo: e.target.result,
          data: formData,
          id: this.chief.id
        }
        this.handleUpdate()
      }
    },
    deleteChiefPhoto (photo) {
      this.chief.photo = ''
      this.handleUpdate()
    }
  }
}
</script>
<style scoped>
.box {
  position: relative;
}
.photo-container, .load-photo-wrapper {
  min-height: 300px;
  position: relative;
}
.delete-photo {
  bottom: 5px;
  position: absolute;
  left: 50%;
  transform: translate(-50%);
}
.switch-wrapper {
  margin: 0 0 15px;
}
.inputs .control {
  margin: 10px 0;
}
.photo-container {
  background-size: cover !important;
  background-position: center !important;
}
.button.is-danger.delete-photo {
  width: auto;
}
</style>



// WEBPACK FOOTER //
// DepartmentChief.vue?494227ca